export default __webpack_public_path__ + "static/media/enrichmydata_black.c72916b8.png";